import HeaderWrapper from "@/features/header/HeaderWrapper";
import { Outlet } from "react-router";

const LoggedIn = () => {
  return (
    <>
      <HeaderWrapper />
      <Outlet />
    </>
  );
};

export default LoggedIn;
